/* ============================================================================
 * ewd-alta-idioma.js  ·  v4  ·  2026-08-19  ·  eWheel / IT
 * ----------------------------------------------------------------------------
 * Parches PROPIOS sobre el formulario de /pages/alta-profesionales, que pinta
 * la theme app extension "ewheel-registro-b2b-479" (UPANGO) y que envia a
 * Salesforce Web-to-Lead.
 *
 * (El nombre del fichero viene de la v1, que solo hacia el idioma. Se mantiene
 *  para no tener que tocar layout/theme.liquid en cada cambio.)
 *
 * v1 idioma · v2 modelo 036 opcional · v3 recargo elegible
 * v4 direccion de envio: FLAG INVERTIDO corregido + visible por defecto
 *
 * ROLLBACK TOTAL:   quitar la linea <script> de layout/theme.liquid.
 * ROLLBACK PARCIAL: poner en false el interruptor correspondiente.
 * ==========================================================================*/
(function () {
  'use strict';

  // ---- INTERRUPTORES -------------------------------------------------------
  var FIX_IDIOMA           = true;   // "Castellano" -> "Español"
  var FIX_MODELO_036       = true;   // el 036 deja de ser obligatorio   (JA, 19/08)
  var FIX_RECARGO          = true;   // el recargo se puede desmarcar    (JA, 19/08)
  var FIX_DIRECCION_ENVIO  = true;   // flag invertido + visible de entrada (JA, 19/08)

  var RECARGO_POR_DEFECTO = false;   // desmarcado (solo aplica a autonomos minoristas)
  var ENVIO_DESMARCADO    = true;    // "usar la misma direccion" desmarcado de entrada

  var AVISO_ADJUNTO = 'Si ahora no puedes adjuntarlo, envíalo a altasnuevas@ewheel.es ' +
                      'para que podamos completar tu alta.';

  var ID = {
    form:    'formularioRegistrarB2bNew',
    idioma:  'preferred_language',      // <select name="00NTs000004Acfn">
    m036:    'salesforce_modelo_036',   // adjunto modelo 036/037
    recargo: '00NTs000004Acfv',         // checkbox "deseo aplicar recargo"
    reFile:  'salesforce_re_file',      // adjunto justificante del recargo
    envio:   '00NTs000004Acg5'          // checkbox "usar la misma direccion de envio"
  };
  // Los checkbox NO viajan solos: lo que llega a Salesforce son estos hidden espejo.
  var HID_RECARGO = 'input[type=hidden][name="00NTs000004Acfv"]';
  var HID_ENVIO   = 'input[type=hidden][name="00NTs000004Acg5"]';
  var CAMPOS_ENVIO = ['shipping_street','shipping_city','shipping_zip',
                      'shipping_country','shipping_state'];

  var $ = function (id) { return document.getElementById(id); };

  var intencionRecargo = RECARGO_POR_DEFECTO;
  var intencionFijada  = false;

  // -------------------------------------------------------------------------
  function fixIdioma() {
    var s = $(ID.idioma);
    if (!s) return false;
    for (var i = 0; i < s.options.length; i++) {
      var o = s.options[i];
      if (o.value === 'es' && /castellano/i.test(o.text)) o.text = 'Español';
    }
    return true;
  }

  // -------------------------------------------------------------------------
  // No basta con poner required=false: el JS de la app lo reasigna en cada
  // cambio. Se interviene la propiedad para que sus asignaciones no tengan
  // efecto y el atributo nunca se ponga (el atributo es lo que mira el
  // navegador para bloquear el envio).
  function hacerOpcional(f) {
    if (!f) return false;
    if (!f.dataset.ewdNeutralizado) {
      try {
        f.required = false;
        f.removeAttribute('required');
        Object.defineProperty(f, 'required', {
          configurable: true,
          get: function () { return false; },
          set: function () { }
        });
        f.dataset.ewdNeutralizado = '1';
      } catch (e) {
        f.removeAttribute('required');
        if (window.console) console.warn('[EWD alta] no se pudo neutralizar', f.id, e);
      }
    }
    if (f.hasAttribute('required')) f.removeAttribute('required');
    return true;
  }

  function ponerAviso(f) {
    if (!f || f.dataset.ewdAviso) return;
    var p = document.createElement('p');
    p.className = 'ewd-aviso-adjunto';
    p.style.cssText = 'font-size:.9em;line-height:1.35;margin:.4rem 0 0;';
    p.textContent = AVISO_ADJUNTO;
    (f.parentNode || f).appendChild(p);
    f.dataset.ewdAviso = '1';
  }

  // Blinda el valor de un hidden: la app deja de poder escribirlo y el valor
  // lo calcula `fn`. Se escribe por atributo, que es lo que se envia.
  function blindarHidden(h, fn) {
    if (!h) return null;
    if (!h.dataset.ewdBlindado) {
      try {
        h.setAttribute('value', fn());
        Object.defineProperty(h, 'value', {
          configurable: true,
          get: function () { return this.getAttribute('value') || ''; },
          set: function () { }
        });
        h.dataset.ewdBlindado = '1';
      } catch (e) {
        if (window.console) console.warn('[EWD alta] no se pudo blindar', h.name, e);
      }
    }
    h.setAttribute('value', fn());
    return h;
  }

  // -------------------------------------------------------------------------
  function fixModelo036() {
    var f = $(ID.m036);
    if (!f) return false;
    hacerOpcional(f);
    ponerAviso(f);
    return true;
  }

  // -------------------------------------------------------------------------
  // El bug de la app: dentro de su propio handler de `change` hace
  //   if (isSpainSelected && !recargo.checked) { recargo.checked = true; }
  // asi que al desmarcarlo se vuelve a marcar. Se sustituye el nodo por un clon
  // (un clon no arrastra listeners) y se guarda la intencion del usuario.
  function fixRecargo() {
    var c = $(ID.recargo);
    if (!c) return false;

    if (!c.dataset.ewdClonado) {
      var limpio = c.cloneNode(true);
      limpio.dataset.ewdClonado = '1';
      c.parentNode.replaceChild(limpio, c);
      c = limpio;
      if (!intencionFijada) { intencionRecargo = RECARGO_POR_DEFECTO; intencionFijada = true; }
      c.addEventListener('change', function () {
        intencionRecargo = c.checked;
        sincronizarRecargo();
      });
    }
    if (c.checked !== intencionRecargo) c.checked = intencionRecargo;

    hacerOpcional($(ID.reFile));
    ponerAviso($(ID.reFile));
    sincronizarRecargo();
    return true;
  }

  function sincronizarRecargo() {
    blindarHidden(document.querySelector(HID_RECARGO),
                  function () { return intencionRecargo ? '1' : '0'; });
    var f = $(ID.reFile);
    if (f) {
      var caja = f.closest('.form-group, .field, .form-field, div');
      if (caja) caja.style.display = intencionRecargo ? '' : 'none';
      if (!intencionRecargo) { try { f.value = ''; } catch (e) {} }
    }
  }

  // -------------------------------------------------------------------------
  // Direccion de envio. Dos cosas:
  //  a) EL FLAG VIAJA INVERTIDO. Comprobado en vivo: checkbox marcado ("usar la
  //     misma") -> hidden "0"; desmarcado ("otra direccion") -> hidden "1". Por
  //     eso en Salesforce sale "usar misma direccion" justo cuando el cliente
  //     puso otra. Aqui se manda 1 = misma, 0 = otra.
  //  b) La casilla venia marcada, asi que el bloque de envio estaba oculto y
  //     los clientes no sabian que podian dar dos direcciones. Se desmarca.
  //     Los campos de envio NO son obligatorios (comprobado), asi que esto no
  //     bloquea a nadie: si el cliente no rellena nada, el flag vuelve a "misma
  //     direccion" solo, y el alta se comporta como hasta hoy.
  function envioVacio() {
    return CAMPOS_ENVIO.every(function (id) {
      var e = $(id);
      return !e || !String(e.value || '').trim();
    });
  }

  function fixDireccionEnvio() {
    var c = $(ID.envio);
    if (!c) return false;

    if (ENVIO_DESMARCADO && !c.dataset.ewdDesmarcado) {
      c.dataset.ewdDesmarcado = '1';
      if (c.checked) c.click();          // click: la app despliega su bloque
    }
    sincronizarEnvio();
    return true;
  }

  function sincronizarEnvio() {
    var c = $(ID.envio);
    if (!c) return;
    blindarHidden(document.querySelector(HID_ENVIO), function () {
      // 1 = usar la misma direccion · 0 = hay direccion de envio propia
      return (c.checked || envioVacio()) ? '1' : '0';
    });
  }

  // -------------------------------------------------------------------------
  function aplicar() {
    var ok = false;
    try {
      if (FIX_IDIOMA)          ok = fixIdioma()          || ok;
      if (FIX_MODELO_036)      ok = fixModelo036()       || ok;
      if (FIX_RECARGO)         ok = fixRecargo()         || ok;
      if (FIX_DIRECCION_ENVIO) ok = fixDireccionEnvio()  || ok;
    } catch (e) {
      if (window.console) console.warn('[EWD alta-profesional]', e);
    }
    return ok;
  }

  function sincronizarTodo() {
    try {
      if (FIX_RECARGO)         sincronizarRecargo();
      if (FIX_DIRECCION_ENVIO) sincronizarEnvio();
    } catch (e) { }
  }

  function arrancar() {
    aplicar();

    var intentos = 0;
    var t = setInterval(function () {
      if (aplicar() || ++intentos > 40) clearInterval(t);   // 40 x 250 ms = 10 s
    }, 250);

    if (window.MutationObserver) {
      new MutationObserver(function () { aplicar(); })
        .observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('change', function () { aplicar(); }, false);
    document.addEventListener('input',  sincronizarTodo, false);

    // Ultima palabra justo antes de enviar.
    document.addEventListener('submit', function (ev) {
      if (ev.target && ev.target.id === ID.form) sincronizarTodo();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();